"use client";
import Image from "next/image";
import AnimatedText from "@/components/common/AnimatedText";
import ModalVideo from "react-modal-video";
import { useEffect, useState } from "react";
export default function About() {
  const [about, setAbout] = useState(null);

  useEffect(() => {
    const fetchAbout = async () => {
      try {
        const response = await fetch("/api/web-content");
        if (response.ok) {
          const data = await response.json();
          if (data?.about) {
            setAbout(data.about);
          }
        }
      } catch (error) {
        console.error("Failed to fetch About:", error);
      }
    };
    fetchAbout();
  }, []);

  const [isOpen, setOpen] = useState(false);
  return (
    <>
      <section
        id="about"
        className="about-section fix section-padding scrollSpySection"
      >
        <div className="container">
          <div className="about-wrapper">
            <div className="row">
              <div className="col-lg-6">
                <div className="about-image">
                  <div className="about-us-images">
                    <div className="about-image-box-1">
                      <div className="about-us-img-1">
                        <figure className="image-anime reveal">
                          <Image
                            src="/assets/img/about1.png"
                            alt=""
                            width={923}
                            height={968}
                          />
                        </figure>
                      </div>
                      <div className="about-us-img-2">
                        <figure className="image-anime">
                          <Image
                            src="/assets/img/about2.png"
                            alt=""
                            width={880}
                            height={914}
                          />
                        </figure>
                      </div>
                    </div>
                    <div className="about-image-box-2">
                      <div className="about-experience-box">
                        <figure className="image-anime">
                          <Image
                            src="/assets/img/about3.png"
                            alt=""
                            width={880}
                            height={914}
                          />
                        </figure>
                      </div>

                      <div className="about-us-img-3">
                        <figure className="image-anime">
                          <Image
                            src="/assets/img/about5.png"
                            alt=""
                            width={820}
                            height={860}
                          />
                        </figure>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 align-self-center">
                <div className="about-content">
                  <div className="section-title">
                    <h6 className="wow fadeInUp">
                      <span className="mini-dot"></span> About Arena Water Park
                    </h6>
                    <h2 className="splt-txt wow ">
                      <AnimatedText text="A Destination Where Fun Flows Non-Stop." />
                    </h2>
                  </div>

                  {about?.content ? (
                    <div
                      className="mt-3 mt-md-0 wow fadeInUp"
                      data-wow-delay=".4s"
                      dangerouslySetInnerHTML={{ __html: about.content }}
                    />
                  ) : (
                    <p
                      className="mt-3 mt-md-0 wow fadeInUp"
                      data-wow-delay=".4s"
                    >
                      Welcome to Arena Water Park — your ultimate destination
                      for water-park fun, leisure and recreation in
                      Visakhapatnam. Nestled amidst serene surroundings and
                      built for fun-seekers of all ages, Arena Water Park
                      blends thrilling water rides, family-friendly attractions
                      and relaxing amenities to deliver memorable experiences
                      for everyone.
                    </p>
                  )}

                  <ul
                    className="list-items wow fadeInUp mb-0"
                    data-wow-delay=".2s"
                  >
                    <li>
                      <i className="fa-solid fa-circle-check"></i>
                      <b>Designed for All Ages Groups</b> : Whether you’re a
                      young adventurer, a thrill lover, or looking for family
                      fun, Arena Water Park offers experiences everyone can
                      enjoy together.
                    </li>
                    <li>
                      <i className="fa-solid fa-circle-check"></i>
                      <b>Exciting & Ever-Evolving Attractions</b> : Each visit
                      brings something new innovative rides, interactive play
                      zones, and fresh experiences that keep the fun feeling
                      brand new.
                    </li>
                    <li>
                      <i className="fa-solid fa-circle-check"></i>
                      <b>A Place to Celebrate Fun & Togetherness</b> : Arena is
                      more than a water park it's where families, friends, and
                      communities come together to relax, play, and celebrate
                      life.
                    </li>
                    <li>
                      <i className="fa-solid fa-circle-check"></i>
                      <b>Safe, Clean & Family-First Environment</b> :Your safety
                      and comfort are our top priority, with well-maintained
                      facilities, hygiene standards, and trained staff
                      throughout the park.
                    </li>

                    <li>
                      <i className="fa-solid fa-circle-check"></i>
                      <b>Every Visit Feels Special</b> : No two visits are ever
                      the same—because at Arena Water Park, the fun never fades,
                      it only gets better.
                    </li>
                  </ul>
                  <div className="hide-btn">
                    <a
                      href="/about"
                      className="testimonials-btn"
                      style={{ cursor: "pointer" }}
                    >
                      More About Us
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>{" "}
      <ModalVideo
        channel="youtube"
        youtube={{ mute: 0, autoplay: 0 }}
        isOpen={isOpen}
        videoId="Cn4G2lZ_g2I"
        onClose={() => setOpen(false)}
      />{" "}
    </>
  );
}
